<template>
	<section>
		<!-- 左边开始 -->
		<selectProductVue ref="selectProduct" isCashier :appointmentId="appointment_id" :appointmentType="cart_type" :userId="user_id" :selProduct="selProduct" @addItem="addItem"></selectProductVue>
		<!-- 左边结束 -->

		<!-- 右边开始 -->
		<div class="right" >
			<div class="right_title">
				消费清单
			</div>
			<!-- 会员搜索 -->
			<div id="setchContent" class="search_user_box con_box a_center p_tb14 m_bottom20" v-show="!userData.status" style="border-radius: 0;height: 20px;"
			 v-if="lock_user == false">
				<el-autocomplete @select="handleSelect" class="inline-input w-p100 setchBox1" prefix-icon="el-icon-search" v-model="user_nick"
				 :fetch-suggestions="querySearch" placeholder="会员昵称、手机号码" clearable>
					<template slot-scope="{item}">
						<div class="search_prop_list flex">
							<img v-if="item.user_avatar" class="img" :src="(item.user_avatar && (item.user_avatar).indexOf('https') == -1) ? `${$config.img_url}${item.user_avatar}` : item.user_avatar">
							<img v-else class="img" :src="headUserImg">
							<div class="text">
								<p class="font14">{{item.user_nickname}}</p>
								<p class="font12">{{item.mobile}}</p>
							</div>
						</div>
					</template>
				</el-autocomplete>
			</div>
			<div class="search_user_box con_box a_center p_tb14 m_bottom20" v-show="!userData.status" style="border-radius: 0;height: 20px;" v-if="lock_user == true">
				<span style="margin-left:20px;">{{user_nick}}</span>
			</div>
			<!-- 商品列表开始 -->
			<div class="right-main">
				<div v-for="items in tableData" :key="items.cart_id" >
					<pop-item :items="items" :salesManList="salesManList"  @del="popItemDel" @quantity="popItemQuantity" @updateItem="popItemUpdate" @loading="loadingRight = true"></pop-item>
				</div>
			</div>
			<div class="right-textarea">
				<el-input type="textarea" :rows="2" placeholder="请输入订单备注" v-model="order_remark"> </el-input>
			</div>
			<div class="right-footer">
				<div class="price" >
					<span>
						待收款金额：￥{{countAmount | currencyFilters}}  
					</span>
					<span class="deposit" v-if="deposit_amount > 0"> 
						
						{{card_deductible_amount > 0 ? '预付卡抵扣' : '已付定金'}}：￥{{deposit_amount | currencyFilters}} 
					</span>
				</div>		
				<div class="button" v-if="operate_type == '1'">
					<el-button size="small" @click="clearAllItem">清除收款项</el-button>
					<el-button @click="goToCreate" type="primary" size="small" :loading="loadingRight" >收款</el-button>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import popItem from '@/components/main/popItem.vue'
	import { calculate } from '@/api/common'
	import { isEmpty } from '@/common/js/util'
	import selectProductVue from '@/components/main/selectProduct.vue'
	
	export default {
		components: {
			popItem,
			selectProductVue,
		},
		data() {
			return {
				goodslistheight: {
					top: '145px',
				},
				keywords: '',
				goods_id: '0',
				goods_sku_id: '0',
				service_id: '0',
				sevice_skue_id: '0',
				cart_type: 'goods', //默认传商品类型
				default_quantity: 1,

				loadingRight: false,
				loadingData: false,
				loadingAdd: false,

				tableData: [], //购物车清单记录
				tabSelect: '0', //默认商品

				goodsCategoryList: [], //商品分类数据
				serviceCategoryList: [], //服务分类数据

				goodsIndex: '0', //商品分类选中索引
				serviceIndex: '0', //服务分类选中索引
				goodsList: [], //商品数据
				serviceList: [], //服务数据

				goods_cateogry_id: '0', //商品分类ID
				service_category_id: '0', //服务分类ID

				userData: {
					status: false,
					info: {},
					pet: [],
					user_search: '',
				},
				headUserImg: require('../../assets/head/user.png'),
				headPetImg: require('../../assets/head/pet.png'),

				pageLimit: 50,

				selectItem: {}, //选中的商品、服务对象
				skuSelectedList: [], //选中的SKU
				btnAddFlag: false,

				selectedSkuPrice: '0',
				selectedSkuError: '',

				salesManList: [],
				totalAmount: '0',

				user_id: '0',
				user_nick: '',
				order_remark: '',
				secondCategoryList: [],
				secondGoodsIndex: '0',
				goods_second_cateogry: '0',

				goodsDialogVisible: false,
				serviceDialogVisible: false,

				deposit_amount:0 ,
				page: 1,
				count: 0,
				servicePage: 1,
				serviceCount: 0,


				appointment_id: '0',
				operate_type: '1',
				lock_user: false,

				main_data:'',
				isQuickAdd:true,
				queryText:'查询',
				sku_goods: [],
				sku_service: [],
				selProduct: {
					goods_id: new Set(),
					goods_sku_id: new Set(),
					service_id: new Set(),
					service_sku_id: new Set(),
				},
				child: false,
				card_deductible_amount: 0,
			}
		},
		computed: {
			noGoodsMore() {
				if (this.count == 0) {
					return true;
				}
				return this.count <= this.goodsList.length;
			},
			noServiceMore() {
				if (this.serviceCount == 0) {
					return true;
				}
				return this.serviceCount <= this.serviceList.length;
			},
			goodsDisabled() {
				return this.loadingAdd || this.noGoodsMore;
			},
			serviceDisabled() {
				return this.loadingAdd || this.noServiceMore;
			},
			countAmount() {
				if (this.loadingRight) {
					return ''
				}
				return this.totalAmount;
				// let amount = parseFloat(this.totalAmount);
				// if(amount >= this.deposit_amount){
				// 	amount = calculate(amount,'-',this.deposit_amount)
				// }
				// return amount;
			},
		},
		mounted() {
			this.child = this.$refs.selectProduct;
			this.initData();
		},
		created() {
			const main_data = localStorage.getItem('main_data');
			if (!isEmpty(main_data)) {
				this.main_data = main_data
				const temp_main_data = JSON.parse(main_data);
				this.appointment_id = temp_main_data.appointmentId;
				this.cart_type 		= temp_main_data.appointmentType;
				this.user_id 		= temp_main_data.user_id;

				this.operate_type 	= temp_main_data.operate_type;
				this.lock_user 		= true;
				localStorage.removeItem('main_data');
				this.addItem();
			}
		},
		watch: {
			screenWidth(val) {
				this.height = val
			},
			// tableData:{
			// 	handler(val){
			// 		this.tableData = val;
			// 	},
			// 	deep: true,
			// 	immediate: true,
			// }
		},
		methods: {
			initData(){
				const postDataList = [
					{
						x_method   : 'com.get.merchant.salesman.list_all'
					}
				];
				if (this.user_id == 0) {
					postDataList.push({
						x_method : 'com.set.order.checkout.cart.user_project_remove',
						params: { user_id: this.user_id }
					});
				}
				this.loadingAdd = true;
				this.$apis(postDataList).then(res_list => {
					for (let x in res_list) {
						let res = res_list[x]
						if (res.status == 10000) {
							switch (x){
								case 'com.get.merchant.salesman.list_all' :
								{
									this.salesManList = res.data.list.map((item) => ({
										...item,
										realname: item.realname || item.mobile,
									}));
									break;
								}	
								default:
									break;
							}
						}else {
							this.$message.error(res.info);
						}
					}
				}).finally(()=>{
					this.loadingAdd = false
				});
			},
			popItemDel(cart_id) {
				this.$confirm('是否删除该项?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$ajax({
						method: 'com.set.order.checkout.cart.del',
						data: {
							cart_id: cart_id,
						}
					}).then(res => {
						if (res.status === 10000) {
							this.refreshCart();
						}else{
							this.$message.error(res.info);
						}
					})
				});
			},
			popItemQuantity(value, cart_id) {
				this.$ajax({
					x_version	: '2.5',
					method		: 'com.set.order.checkout.cart.update_quantity',
					data: {
						cart_id: cart_id,
						quantity: value,
					}
				}).then(res => {
					this.refreshCart();
					if (res.status !== 10000) {
						this.$message.error(res.info);
					}
				}).finally(()=>{
					this.loadingRight = false;
				})
			},
			popItemUpdate(obj) {
				this.$ajax({
					x_version: '2.5',
					method: 'com.set.order.checkout.cart.update_item',
					data: {
						cart_id					: obj.cart_id,
						use_user_card			: obj.use_user_card,
						use_member_price		: obj.use_member_price,
						is_gifts				: obj.is_gifts,
						project_subtotal_amount	: obj.project_subtotal_amount,
						merchant_uid			: obj.merchant_uid,
						waiter_uid				: obj.waiter_uid,
					}
				}).then(res => {
					if (res.status == 10000) {
						this.refreshCart();
					} else {
						this.$message.error(res.info);
					}
				})
			},
			handleSelect(item) {
				if (this.user_id != item.user_id) {
					this.tableData = [];
				}
				this.user_id = item.user_id;
				this.user_nick = item.user_nickname || item.mobile;
				
				//选中的商品是否存在，存在着将该购物车挂在该会员上
				if (this.tableData.length > 0) {
					this.$ajax({
						method	: 'com.set.order.checkout.cart.adopt',
						x_version: '2.5',
						data: {
							user_id: this.user_id,
						}
					}).then(res => {
						if (res.status == 10000) {
							this.refreshCart();
							
							if (this.child) {
								this.child.goodsDataList();
								this.child.serviceDataList();
							}
						}
					})
				} else { //获取该会员的购物清单
					this.refreshCart();
					this.child.goodsDataList();
					this.child.serviceDataList();
				}
			},
			querySearch(queryString, cb) {
				this.$ajax({
					method : 'com.get.merchant.user.list',
					data: {
						page: 1,
						user_search: queryString
					}
				}).then(res => {
					if (res.status == 10000) {
						const results = res.data.list;
						cb(results);
					} else {
						this.$message.error(res.info);
					}
				})
			},
			//清除清单
			clearAllItem() {
				this.$confirm('是否清空购物清单?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$ajax({
						method: 'com.set.order.checkout.cart.user_project_remove',
						data: {
							user_id: this.user_id,
						}
					}).then(res => {
						if (res.status === 10000) {
							this.main_data = ""
							this.refreshCart();
						}
					})
				}).catch(()=>{});
			},
			//去创建订单
			goToCreate() {
				if(this.main_data != ''){
					localStorage.setItem("main_data", this.main_data);
				}
				this.$router.push({
					name: '收银付款',
					params: {
						uid: this.user_id
					}
				});
			},
			//通过输入条形码进行添加商品或服务
			addItem(obj = {}) {
				const postData = {
					x_version: '2.5',
					method: 'com.set.order.checkout.cart.add',
					data: {
						user_id			: this.user_id,
						goods_code		: this.isQuickAdd ? this.keywords: '',
						goods_id		: this.goods_id,
						goods_sku_id	: this.goods_sku_id,
						service_id		: this.service_id,
						service_sku_id	: this.service_sku_id,
						cart_type		: this.cart_type,
						quantity		: this.default_quantity,
						appointment_id	: this.appointment_id,
						...(isEmpty(this.user_id) || isEmpty(this.appointment_id) ? { use_member_price: 1 } : {}),
						...obj
					}
				}
				
				this.loadingRight = true;
				this.$ajax(postData).then(res => {
					if (res.status == 10000) {
						this.refreshCart();
					} else {
						this.$message.error(res.info);
					}
				}).finally(()=>{
					this.loadingRight = false;
				})
				// this.clearParams();
			},
			//清除新增的参数数据
			// clearParams() {
			// 	if(this.isQuickAdd){
			// 		this.keywords = '';
			// 		this.queryText = '查询'
			// 	}
			// 	this.goods_id = '';
			// 	this.goods_sku_id = '';
			// 	this.service_id = '';
			// 	this.service_sku_id = '';
			// },
			//获取购物车清单
			refreshCart() {
				this.loadingRight = true;
				this.totalAmount = '';
				this.$ajax({
					method		: 'com.get.order.checkout.cart.user_project',
					x_version	: '2.5',
					data: {
						user_id: this.user_id,
					}
				}).then(res => {
					if (res.status == 10000) {
						this.totalAmount = res.data.payable_amount;
						this.user_nick = res.data.user.user_nickname || res.data.user.mobile;
		
						this.selProduct = {
							goods_id: new Set(),
							goods_sku_id: new Set(),
							service_id: new Set(),
							service_sku_id: new Set(),
						}
						this.deposit_amount = 0
						this.card_deductible_amount = 0
						console.log('res.data.list', res.data.list);
						this.tableData = res.data.list.reduce((tempList, tempRow) => {
							const { project_type } = tempRow
							const idKey = `${project_type}_id`;
							const skuIdKey = `${project_type}_sku_id`;
						
							if (['goods', 'service'].includes(project_type)){
								if (tempRow[skuIdKey] > 0) {
									this.selProduct[skuIdKey].add(tempRow[skuIdKey]);
								}else if (tempRow[idKey] > 0) {
									this.selProduct[idKey].add(tempRow[idKey]);
								}
							}
							if((project_type == "foster" && res.data.card_deductible_amount == '0.00' && res.data.deposit_amount != '0.00') || tempRow.user_card_use_lock == 1){
								this.deposit_amount += Number(res.data.deposit_amount)
								this.card_deductible_amount += Number(res.data.card_deductible_amount) 	
								tempRow.deposit_amount = res.data.deposit_amount;
							}

							tempRow.skuList = (tempRow.project_sku) ? JSON.parse(tempRow.project_sku) : [];
							
							tempRow.is_goods = tempRow.goods_id > 0 ? true : false;
							
							tempRow.discount_amount = 0;
							tempRow.discount_rate = 0;
							//会员价折扣金额
							tempRow.member_discount_amount = 0;
							if (tempRow.use_member_price == 1 && tempRow.app_member_price.discount_status == 1 ) {

								
								tempRow.member_discount_amount =   calculate(tempRow.project_original_price, '-', tempRow.app_member_price.discount_price )
								// if (tempRow.app_member_price.discount_type == '1') {
								// 	tempRow.member_discount_amount = calculate(1 - tempRow.app_member_price.discount, '*', tempRow.project_original_price);
								// } else if (tempRow.app_member_price.discount_type == '2'){
								// 	tempRow.member_discount_amount = calculate(tempRow.project_original_price, '-', tempRow.app_member_price.discount_price)
								// }
							} 
							// else {
							// 	if (tempRow.project_original_price != tempRow.project_retail_price) {
							// 		tempRow.member_discount_amount = calculate(tempRow.project_original_price, '-', tempRow.project_retail_price)
							// 	}
							// }
							
							//商品折扣金额
							//先算出会员折扣 和 销售价相加 如果和小计不相等。那么就逆推折扣
							const temp_retail_price = Number(calculate(tempRow.project_retail_price,'*', tempRow.quantity))

							if (temp_retail_price > tempRow.project_subtotal_amount) {
								if (tempRow.use_user_card > 0 && tempRow.quantity > 1) {
									tempRow.discount_amount = calculate(calculate(temp_retail_price, '-', tempRow.project_subtotal_amount), '-',tempRow.project_retail_price);
								}else {
									tempRow.discount_amount = calculate(temp_retail_price, '-', tempRow.project_subtotal_amount);
								}
							}
							tempList.push(tempRow);	
							return tempList;
						}, []);
					} else {
						this.$message.error(res.info);
					}
				}).finally(()=>{
					this.loadingRight = false
				}); 
			},
		}
	}	
</script>

<style>
	.right .el-dialog__wrapper {
		right: 445px
	}

	.left .pa_btn {
		font-size: 12px;
		padding: 0 5px;
		height: 30px;
		min-width: 60px;
	}

	.left .pa_btn.on {
		background: #FF700B;
		color: #fff;
	}

	.left {
		position: fixed;
		bottom: 0;
		top: 70px;
		right: 447px;
		left: 150px;
		background-color: #FFFFFF;
		border-right: 0.5px solid #f8f8f8;
		z-index: 10;
	}

	.left .heard {
		margin: 5px;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		z-index: 30;
	}

	.left .heard .input {
		margin: 5px;
		display: inline;
	}

	.left .heard .input .icon {
		display: inline-block;
		line-height: 36px;
		font-size: 18px;
	}

	.left .heard .tabs {
		margin: 5px;
	}

	/* .left .heard .tabs .el-tabs__content{
	height: 70px;
    padding: 5px;
} */
	.left .heard .input .el-input__inner {
		border-radius: 0px;
	}

	.left .content {
		position: absolute;
		top: 160px;
		left: 0;
		right: 0;
		bottom: 0;
		margin: 10px 10px 0 10px;
		overflow: auto;
		border-left: 0px;
	}

	.left .content_2 {
		position: absolute;
		top: 140px;
		left: 0;
		right: 0;
		bottom: 0;
		margin: 10px;
		overflow: auto;
	}

	.right {
		position: fixed;
		bottom: 0;
		top: 70px;
		right: 0;
		min-width: 445px;
		background-color: #FFFAF7;
	}

	.right_title {
		height: 40px;
		line-height: 40px;
		background-color: #ff6f0b;
		color: #FFFFFF;
		font-weight: 600;
		text-align: center;
	}

	.goods_list_box {
		/*box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);*/
		box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
		margin: 5px 2px;
		cursor: pointer;
		padding: 5px;
		height: 100px;
		display: inline-block;
		width: 93%;
	}

	.goods_list_box .title {
		font-size: 14px;
		height: 70px;
		font-weight:bold;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
	}

	.goods_list_box .price {
		font-size: 12px;
		color: #FF700B;
		margin-top: 5px;
		height: 30px;
		line-height: 30px;
	}

	#setchContent .setchBox1 {
		width: 440px;
	}

	.right-main {
		position: absolute;
		font-size: 12px;
		bottom: 140px;
		top: 100px;
		right: 0;
		width: 445px;
		z-index: 20;
		overflow: auto;
	}

	.right-main .item {
		height: 130px;
		background-color: #ffffff;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		cursor: pointer;
		margin-bottom: 10px;
		border: 1px solid #ffffff
	}

	.right-main .item:hover {
		border: 1px solid #ffb37c
	}


	.item .leftImg {
		display: inline-block;
		/* float: left; */
		border-right: 1px solid #ffb37c;
		height: 130px;
		line-height: 129px;
		width: 12px;
	}

	.item .item-right-main {
		display: inline-block;
		width: 430px;
		height: 129px;
	}

	.item-right-main .item-right-main-top {
		position: relative;
		height: 60%;
		border-bottom: 1px solid #ffb37c;
	}

	.item-right-main .item-right-main-top .top-goodsname {
		position: absolute;
		top: 0px;
		left: 5px;
		height: 50px;
		width: 43%;
		font-size: 12px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.item-right-main .item-right-main-top .top-goodsclass {
		position: absolute;
		bottom: 3px;
		left: 5px;
		height: 20px;
		width: 40%;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.item-right-main .item-right-main-top .top-goodsnum {
		position: absolute;
		top: 5px;
		right: 110px;
		height: 50px;
		width: 120px;
		text-align: left;
	}

	.item-right-main .item-right-main-top .top-goodsnum .el-input-number {
		width: 100px;
	}

	.item-right-main .item-right-main-top .top-goodsprice {
		position: absolute;
		top: 5px;
		right: 40px;
		height: 50px;
		width: 80px;
		text-align: center;
	}

	.item-right-main .item-right-main-top .top-goodsbutton {
		position: absolute;
		top: 0;
		right: 0;
		height: 50px;
		width: 40px;
		text-align: center;
	}


	.item-right-main .item-right-main-footer {
		height: 40%;
	}

	.item-right-main .item-right-main-footer .main-footer-right {
		width: 50%;
		margin: 10px 5px;
	}

	.right-textarea {
		position: absolute;
		bottom: 85px;
		right: 0;
		width: 445px;
		z-index: 17;
	}

	.right-textarea .el-textarea .el-textarea__inner {
		border-radius: 0px;
	}

	.right-footer {
		position: absolute;
		background-color: #FFFFFF;
		bottom: 0;
		right: 0;
		height: 80px;
		width: 445px;
	}

	.right-footer .price {
		font-weight: 600;
		color: #FF700B;
		text-align: left;
		margin: 5px;
		padding-bottom: 5px;
		font-size: 14px;
		border-bottom: 1px solid #ffb37c
	}
	.right-footer .price .deposit{
		color: #948d89;
		text-align: left;
		margin: 5px;
		padding-bottom: 5px;
		font-size: 6px;
	}
	.right-footer .button {
		text-align: right;
		padding: 2px 10px;

	}

	/* 弹窗涉及样式 */
	.goods_info {
		position: relative;
		font-size: 12px;
		padding: 5px 5px;
		border: 1px solid #C0C4CC;
		height: 70px;
	}

	.goods_info .goods_name {
		padding: 5px 10px;
		position: absolute;
		top: 0;
		left: 0;
		width: 48%;
		height: 28px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.goods_info .goods_class {
		padding-left: 10px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 25px;
	}

	.goods_info .goods_price {
		padding: 5px 10px;
		position: absolute;
		top: 0px;
		right: 110px;
		height: 50px;
		width: 130px;
		text-align: center;
	}

	.goods_info .goods_total_price {
		padding: 5px 10px;
		position: absolute;
		top: 0;
		right: 0;
		height: 50px;
		width: 100px;
		text-align: center;
	}

	.selWarpper {
		margin-top: 30px
	}

	.selWarpper .el-select .el-input.is-focus .el-input__inner {
		border: 1px solid #DCDFE6;
		background-color: #fffaf7;
	}

	.selWarpper .el-select .el-input__inner:focus {
		border: 1px solid #DCDFE6;
	}

	.goodCoupon {
		width: 99.5%;
		border: 1px solid #C0C4CC;
		height: 50px;
		line-height: 50px;
		margin-top: -1px;
	}

	.goodCoupon>span {
		display: inline-block;
	}

	.goodCoupon .coupon1 {
		padding: 0 30px 0 16px;
		color: #c0c4cc;
	}

	.goodCoupon .input {
		display: inline-block;
		width: 120px
	}

	.btnSub {
		margin: 10px;
		height: 30px;
		text-align: right;
	}

	
	.selStyle{color:#FF700B;border-color:#FF700B;}
</style>



// WEBPACK FOOTER //
// main.vue?0fcba0e8